import LandingComponent from './Landing.js';
export default LandingComponent;